import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import RaisedButton from 'material-ui/RaisedButton';

import { updateUser } from '../../actions/userActions';

class ActivateUserToggle extends Component {
  state = {
    active: false,
  }

  componentWillMount() {
    this.setState({
      active: this.props.active
    });
  }


  _handleSubmit = event => {
    event.preventDefault();

    this.props.updateUser({
      userData: {
        active: !this.state.active ? 'active' : 'not-active',
      },
      username: this.props.user.username
    }).then(_ => {
      if (this.props.userToUpdate.status === 'updated') {
        this.setState({
          active: !this.state.active,
        })
      }
    })

  }



  render(){
    return(
      <form style={{ display: 'inline-block' }} onSubmit={this._handleSubmit}>
        { this.state.active &&
          <RaisedButton type="submit" label="Suspend" labelStyle={{height: 'auto'}} backgroundColor="#FFC107" />
        }
        { !this.state.active &&
          <RaisedButton type="submit" label="Activate" labelStyle={{height: 'auto', color: 'white'}} backgroundColor="#009688" />
        }
      </form>

    )
  }
}


const mapStateToProps = state => ({ userToUpdate: state.user.updated });
const mapDispatchToProps = { updateUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivateUserToggle));



// WEBPACK FOOTER //
// ./src/components/Users/ActivateUserToggle.js